import Vue from 'vue'
import axios from '../../axios'

export var find = {
  state: {
    participantName: '',
    resultID: '',
    includeScored: false,
    whenFinished: null,
    results: [],
    answersInSelectedResult: []
  },
  mutations: {
    SET_FIND_INCLUDE_SCORED (state, payload){
      Vue.set(state, 'includeScored', payload)
    },
    SET_FIND_RESULTS (state, payload){
      Vue.set(state, 'results', payload)
    },
    SET_FIND_RESULT_ID (state, payload){
      Vue.set(state, 'resultID', payload)
    },
    SET_FIND_ANSWERS (state, payload){
      Vue.set(state, 'answersInSelectedResult', payload)
    },
    CLEAR_FIND_RESULTS (state, payload){
      Vue.set(state, 'results', [])
    },
    SET_FIND_PARTICIPANT (state, payload) {
      // mutate state
      Vue.set(state, 'participantName', payload);
    },
    SET_FIND_DATE (state, payload) {
      // mutate state
      Vue.set(state, 'whenFinished', payload);
    }
  },
  actions: {
    FETCH_PARTICIPANT_RESULTS ({commit, state}, payload) {
      console.dir(payload)
      let params = {};

      if ( payload.resultID ){
        params.resultID = payload.resultID
      }

      if (payload.participant){
        params.participant = payload.participant;
      }

      if (payload.whenFinished){
        params.whenFinished = payload.whenFinished;
      }

      if (payload.includeUnfinished){
        params.includeUnfinished = payload.includeUnfinished;
      }

      console.dir(params)

      axios.get('/qm/find-results', {
          params: params
        }
      ).then((response) => {
        console.dir(response);
        commit('SET_FIND_RESULTS', response.data.value);
      }).catch((err) => {
        console.dir(err)
      })
    },
    FETCH_RESULT_ANSWERS ({commit, state}, payload) {
      axios.get('/qm/get-answers-in-result', {
          params: {
            resultid: payload
          }
        }
      ).then((response) => {
        console.dir(response);
        commit('SET_FIND_ANSWERS', response.data.value);
      }).catch((err) => {
        console.dir(err)
      })
    }
  },
  getters: {
    GET_FIND_INCLUDE_SCORED (state){
      return state.includeScored;
    },
    GET_FIND_PARTICIPANT (state){
      return state.participantName;
    },
    GET_FIND_RESULT (state){
      return state.resultID;
    },
    GET_FIND_DATE (state){
      return state.whenFinished;
    },
    GET_FIND_DATA (state){
      return state.results;
    },
    GET_FIND_ANSWERS (state){
      return state.answersInSelectedResult;
    },
  }
}


